import { ButtonKeys } from 'components/eventView/pages/eventData';
import { ReverseButton } from 'elements/eventView/atomic/ReverseButton';
import { motion } from 'framer-motion';
import { EVariables } from 'libs/styles/styling';
import { useAnalytics } from 'libs/utils/site/analytics';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components/macro';

interface Props {
    key: ButtonKeys;
    className?: string;
    title: string;
    mapImageUrl: string;
    backgroundColor: string;
    color: string;
    linkTo: string;
    tileColor: string;
}

export const ImageBgButton = (props: Props) => {
    const analytics = useAnalytics();
    const navigate = useNavigate();
    const [height, setHeight] = useState(0);
    const [width, setWidth] = useState(0);

    useEffect(() => {
        const img = new Image();
        img.onload = function () {
            setHeight(img.height);
            setWidth(img.width);
        };
        img.src = props.mapImageUrl;
    }, [props.mapImageUrl]);

    function handleClick() {
        analytics.track('event_ui.navigate.clicked', {
            source: 'tile',
            destination: props.key
        });
        navigate(props.linkTo);
    }

    if (height === 0 || width === 0)
        return (
            <S_ImageBgButton
                $background={props.mapImageUrl}
                className={props.className}
                onClick={handleClick}
                $tileColor={props.tileColor}
            >
                <ReverseButton
                    iconName="location-dot"
                    text={props.title}
                    onClick={handleClick}
                    backgroundColor={props.backgroundColor}
                    color={props.color}
                />
            </S_ImageBgButton>
        );

    const anim = {
        backgroundPositionY: ['0px', 150 - height + 10 + 'px', '0px'],
        backgroundPositionX: ['unset', 'unset', 'unset'],
        backgroundSize: [width + 'px', width + 'px', width + 'px']
    };

    return (
        <S_ImageBgButton
            $background={props.mapImageUrl}
            className={props.className}
            onClick={handleClick}
            animate={anim}
            transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
            $tileColor={props.tileColor}
        >
            <ReverseButton
                iconName="location-dot"
                text={props.title}
                onClick={handleClick}
                backgroundColor={props.backgroundColor}
                color={props.color}
            />
        </S_ImageBgButton>
    );
};

const S_ImageBgButton = styled(motion.div)<{ $background: string; $tileColor: string }>`
    position: relative;
    cursor: pointer;
    width: 100%;
    height: 150px;
    border-radius: ${EVariables.Radius1};
    display: flex;
    background-color: ${(props) => props.$tileColor};
    background-image: url(${(props) => props.$background});
    background-repeat: no-repeat;
    align-items: center;
    justify-content: center;
`;
